import { ILocalizationKey } from '@app/core/interfaces/localization';

/**
 * @description
 * Validates whether the provided string key matches the localization key pattern.
 * A valid localization key must start with a double at-sign (@@) followed by at least one character.
 *
 * @example
 * localizationKeyCheck('@@common.button.save'); // returns true
 * localizationKeyCheck('invalid_key'); // returns false
 */
export function localizationKeyCheck(key: ILocalizationKey | string): boolean {
  const localizationKeyPattern = /^@@.+$/;

  return localizationKeyPattern.test(key);
}
